export const RESET_ERROR = 'vzr/RESET_ERROR';

export const FETCH_PAYMENTS = 'vzr/FETCH_PAYMENTS';
export const FETCH_PAYMENTS_FAIL = 'vzr/FETCH_PAYMENTS_FAIL';
export const FETCH_PAYMENTS_SUCCESS = 'vzr/FETCH_PAYMENTS_SUCCESS';

export const FETCH_PAYMENT = 'vzr/FETCH_PAYMENT';
export const FETCH_PAYMENT_FAIL = 'vzr/FETCH_PAYMENT_FAIL';
export const FETCH_PAYMENT_SUCCESS = 'vzr/FETCH_PAYMENT_SUCCESS';

export const FETCH_POLICY_PAYMENTS = 'vzr/FETCH_POLICY_PAYMENTS';
export const FETCH_POLICY_PAYMENTS_FAIL = 'vzr/FETCH_POLICY_PAYMENTS_FAIL';
export const FETCH_POLICY_PAYMENTS_SUCCESS = 'vzr/FETCH_POLICY_PAYMENTS_SUCCESS';

export const CREATE_PAYMENT = 'vzr/CREATE_PAYMENT';
export const CREATE_PAYMENT_FAIL = 'vzr/CREATE_PAYMENT_FAIL';
export const CREATE_PAYMENT_SUCCESS = 'vzr/CREATE_PAYMENT_SUCCESS';

export const UPDATE_PAYMENT = 'vzr/UPDATE_PAYMENT';
export const UPDATE_PAYMENT_FAIL = 'vzr/UPDATE_PAYMENT_FAIL';
export const UPDATE_PAYMENT_SUCCESS = 'vzr/UPDATE_PAYMENT_SUCCESS';

export const DELETE_PAYMENT = 'vzr/DELETE_PAYMENT';
export const DELETE_PAYMENT_FAIL = 'vzr/DELETE_PAYMENT_FAIL';
export const DELETE_PAYMENT_SUCCESS = 'vzr/DELETE_PAYMENT_SUCCESS';

export const UPLOAD_INVOICE = 'vzr/UPLOAD_INVOICE';
export const UPLOAD_INVOICE_FAIL = 'vzr/UPLOAD_INVOICE_FAIL';
export const UPLOAD_INVOICE_SUCCESS = 'vzr/UPLOAD_INVOICE_SUCCESS';
